import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=c820c436&"
import script from "./PasswordResetView.vue?vue&type=script&lang=js&"
export * from "./PasswordResetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports